import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = { ref: "root" }
const _hoisted_2 = {
  key: 1,
  class: "card shadow-sm mb-3"
}
const _hoisted_3 = { class: "card-body d-flex flex-wrap align-items-center gap-3" }
const _hoisted_4 = { class: "fw-semibold" }
const _hoisted_5 = {
  key: 0,
  class: "card-footer bg-white small text-muted"
}
const _hoisted_6 = {
  key: 2,
  class: "alert alert-primary d-flex align-items-center gap-3 py-2"
}
const _hoisted_7 = { class: "fw-semibold" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 3,
  class: "text-muted mb-3"
}
const _hoisted_10 = { class: "col-xl-3 col-lg-4 col-sm-6" }
const _hoisted_11 = {
  key: 0,
  class: "page-drop-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_picker = _resolveComponent("file-picker")!
  const _component_photo_tile = _resolveComponent("photo-tile")!
  const _component_upload_tile = _resolveComponent("upload-tile")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_photo_lightbox = _resolveComponent("photo-lightbox")!
  const _component_undo_toast = _resolveComponent("undo-toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rejectedNames, (name) => {
      return (_openBlock(), _createElementBlock("div", {
        key: name,
        class: "alert alert-danger"
      }, [
        _cache[6] || (_cache[6] = _createTextVNode(" Typ souboru ", -1)),
        _createElementVNode("strong", null, _toDisplayString(name), 1),
        _cache[7] || (_cache[7] = _createTextVNode(" není podporován. ", -1))
      ]))
    }), 128)),
    (_ctx.photosData.length === 0 && _ctx.uploads.length === 0)
      ? (_openBlock(), _createBlock(_component_file_picker, {
          key: 0,
          class: "mb-3",
          compact: false,
          "button-label": "Přidat fotografie",
          "button-class": "btn-primary",
          onSelected: _ctx.filesSelected
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createElementVNode("span", { class: "fw-semibold d-block" }, "Přetáhněte sem fotografie nemovitosti", -1),
            _createElementVNode("span", { class: "text-muted small" }, "nebo klikněte a vyberte je, první bude titulní", -1)
          ]))]),
          _: 1
        }, 8, ["onSelected"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_file_picker, {
              compact: true,
              "button-label": "Přidat fotografie",
              "button-class": "btn-primary",
              onSelected: _ctx.filesSelected
            }, null, 8, ["onSelected"]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.summary), 1),
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "small text-muted" }, "Nebo je přetáhněte kamkoli na stránku. Nahrávají se v pořadí, v jakém je vyberete.", -1))
            ]),
            (_ctx.canRemove && ! _ctx.selecting && _ctx.photosData.length > 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-outline-secondary btn-sm ms-auto",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startSelecting && _ctx.startSelecting(...args)))
                }, [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("span", { class: "far fa-check-square me-1" }, null, -1),
                  _createTextVNode(" Vybrat více ", -1)
                ]))]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.photosData.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "fas fa-star text-warning me-1" }, null, -1)),
                _cache[12] || (_cache[12] = _createTextVNode(" První fotografie je titulní, v dokumentu je na hlavním místě. ", -1)),
                (_ctx.canChangePhotoPosition)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("Pořadí změníte přetažením.")
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])),
    (_ctx.selecting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, "Vybráno " + _toDisplayString(_ctx.selectedIds.length), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-danger",
            disabled: _ctx.selectedIds.length === 0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.removeSelected && _ctx.removeSelected(...args)))
          }, [...(_cache[13] || (_cache[13] = [
            _createElementVNode("span", { class: "fas fa-trash me-1" }, null, -1),
            _createTextVNode(" Smazat vybrané ", -1)
          ]))], 8, _hoisted_8),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-link ms-auto",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.stopSelecting && _ctx.stopSelecting(...args)))
          }, "Zrušit výběr")
        ]))
      : _createCommentVNode("", true),
    (_ctx.isBusy)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
          _cache[14] || (_cache[14] = _createElementVNode("span", {
            class: "spinner-border spinner-border-sm me-2 align-middle",
            role: "status"
          }, null, -1)),
          _createTextVNode(" Nahráno " + _toDisplayString(_ctx.doneCount) + " z " + _toDisplayString(_ctx.totalCount) + ". ", 1),
          (_ctx.canChangePhotoPosition)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Pořadí fotografií můžete měnit, až nahrávání skončí.")
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.photosData.length > 0 || _ctx.uploads.length > 0)
      ? (_openBlock(), _createBlock(_component_draggable, {
          key: 4,
          modelValue: _ctx.photosData,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.photosData) = $event)),
          class: "row g-3 mb-4",
          "item-key": "id",
          handle: ".photo-tile-thumb",
          disabled: ! _ctx.canChangePhotoPosition || _ctx.isBusy || _ctx.selecting,
          onEnd: _ctx.onDragEnd
        }, {
          item: _withCtx(({element: photo, index}) => [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_photo_tile, {
                photo: photo,
                url: _ctx.photoUrl(photo),
                "is-title": index === 0,
                "is-last": index === _ctx.photosData.length - 1,
                "can-describe": _ctx.canDescribe,
                "can-rotate": _ctx.canRotate,
                "can-move": _ctx.canChangePhotoPosition && ! _ctx.isBusy,
                "can-remove": _ctx.canRemove,
                rotating: _ctx.rotatingIds.includes(photo.id),
                "description-state": _ctx.descriptionStates[photo.id] ?? null,
                selecting: _ctx.selecting,
                selected: _ctx.selectedIds.includes(photo.id),
                onOpen: ($event: any) => (_ctx.openLightbox(index)),
                onToggleSelected: ($event: any) => (_ctx.toggleSelected(photo)),
                onDescribe: (text) => _ctx.describe(photo, text),
                onRotate: (angle) => _ctx.rotate(photo, angle),
                onMakeTitle: ($event: any) => (_ctx.changePosition(photo, 0)),
                onMove: (step) => _ctx.changePosition(photo, index + step),
                onRemove: ($event: any) => (_ctx.removeLater([photo], 'Fotografie smazána.'))
              }, null, 8, ["photo", "url", "is-title", "is-last", "can-describe", "can-rotate", "can-move", "can-remove", "rotating", "description-state", "selecting", "selected", "onOpen", "onToggleSelected", "onDescribe", "onRotate", "onMakeTitle", "onMove", "onRemove"])
            ])
          ]),
          footer: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploads, (upload) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-xl-3 col-lg-4 col-sm-6",
                key: upload.key
              }, [
                _createVNode(_component_upload_tile, {
                  upload: upload,
                  onRetry: ($event: any) => (_ctx.retry(upload.key)),
                  onDiscard: ($event: any) => (_ctx.discard(upload.key))
                }, null, 8, ["upload", "onRetry", "onDiscard"])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled", "onEnd"]))
      : _createCommentVNode("", true),
    _createVNode(_component_photo_lightbox, {
      ref: "lightbox",
      items: _ctx.lightboxItems,
      "title-badge": true,
      "can-describe": _ctx.canDescribe,
      "can-rotate": _ctx.canRotate,
      "rotating-ids": _ctx.rotatingIds,
      onDescribe: _cache[4] || (_cache[4] = (id, text) => _ctx.describe(_ctx.findPhoto(id), text)),
      onRotate: _cache[5] || (_cache[5] = (id, angle) => _ctx.rotate(_ctx.findPhoto(id), angle))
    }, null, 8, ["items", "can-describe", "can-rotate", "rotating-ids"]),
    _createVNode(_component_undo_toast, {
      message: _ctx.removalMessage,
      onUndo: _ctx.undoRemoval
    }, null, 8, ["message", "onUndo"]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isDragging)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[15] || (_cache[15] = [
            _createElementVNode("span", { class: "fas fa-images fa-3x mb-3" }, null, -1),
            _createTextVNode(" Pusťte fotografie, přidají se na konec ", -1)
          ]))]))
        : _createCommentVNode("", true)
    ]))
  ], 512))
}